<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Servicios de Herraje</div>
      <div slot="sub-title">Histórico de servicios realizados</div>
      <div slot="right">
        <div class="columns">
          <div class="column"></div>
          <div class="column is-narrow">
            <b-button icon-left="plus" type="is-primary" @click="openFormModal">Crear Servicio</b-button>
          </div>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div class="columns">
        <div class="column">
          <services-table :reload.sync=reload @edit="openFormEdit" />
        </div>
      </div>
    </section>
    <form-modal :active.sync="isModalActive" :service-id.sync="serviceId" @saved="reload = true"/>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import ServicesTable from './ServicesTable'
import FormModal from './FormModal'

export default {
  name: 'home',
  components: {
    HeroBar,
    ServicesTable,
    FormModal
  },
  data () {
    return {
      isModalActive: false,
      serviceId: null,
      reload: false
    }
  },
  methods: {
    openFormModal () {
      this.isModalActive = true
    },
    openFormEdit (data) {
      this.serviceId = data
      this.isModalActive = true
    }
  }
}
</script>
